/*eslint-env jquery*/
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { success } from "../../actions/auth-actions";
import { replace } from "../../actions/nav-actions";
import { login } from "../../api";
import { SecureContainer } from "../../components";

class Login extends Component {
  state = {
    username: "",
    password: "",
  };
  componentDidMount() {
    document.title = "Login - Masar";
  }
  onSubmit(event) {
    event.preventDefault();
    const { username, password } = this.state;
    login(username, password)
      .then((user) => {
        let location = this.props.location || {};
        let from = (location.state || {}).from || {};
        if ("pathname" in from) {
          if (from.pathname.indexOf("login") !== -1) {
            from.pathname = "/";
          }
        }
        this.props.success(user, from.pathname || "/");
        if(user.is_admin){
          this.props.history.push("/main-page");
        }
      })
      .catch((err) => {
        $.Notification.notify(
          "error",
          "bottom right",
          "Authentication Error",
          err.message
        );
      });
  }
  render() {
    return (
      <SecureContainer>
        <form
          onSubmit={this.onSubmit.bind(this)}
          className="form-horizontal m-t-20"
        >
          <div className="form-group row">
            <div className="col-12">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="mdi mdi-account"></i>
                  </span>
                </div>
                <input
                  onChange={(event) => {
                    this.setState({ username: event.target.value });
                  }}
                  className="form-control"
                  type="text"
                  required
                  placeholder="Username"
                />
              </div>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-12">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="mdi mdi-radar"></i>
                  </span>
                </div>
                <input
                  onChange={(event) => {
                    this.setState({ password: event.target.value });
                  }}
                  className="form-control"
                  type="password"
                  required
                  placeholder="Password"
                />
              </div>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-12">
              <button
                className="btn btn-info waves-effect waves-light btn-block"
                type="submit"
              >
                LOGIN
              </button>
            </div>
          </div>
          <div className="form-group row" style={{ margin: "32px 0" }}>
            <div className="col-12 text-center">
              <Link to="/forgot">Forgot your password?</Link>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-12">
              <Link
                to="/create-account"
                className="btn btn-outline-info btn-block"
              >
                CREATE AN ACCOUNT
              </Link>
            </div>
            <br />
            <br />
            <br />
            <span style={{ display: "block", textAlign: "center" }}>
              By continuing you agree to Masar's{" "}
              <a href="/terms" target="_blank">
                Terms of Services
              </a>{" "}
              and{" "}
              <a href="/privacy" target="_blank">
                Privacy Policy
              </a>
              .
            </span>
          </div>
        </form>
      </SecureContainer>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  success(user, routeName) {
    dispatch([success(user), replace(routeName)]);
  },
});

export default connect(null, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/routers/Login/index.js